import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { BffAuthProvider, ProtectedRoute } from '@/services/bffAuth';
import { Layout } from './components/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { FeaturesPage } from './pages/FeaturesPage';
import { MetricsPage } from './pages/MetricsPage';
import { MetricDetailPage } from './pages/MetricDetailPage';
import { ClientsPage } from './pages/ClientsPage';
import { ClientDetailPage } from './pages/ClientDetailPage';
import { CreditsPage } from './pages/CreditsPage';
import { UsageActionsPage } from './pages/UsageActionsPage';

// The BFF owns OIDC end-to-end: /signin-oidc and /signout-callback-oidc are
// server-side endpoints, not React routes. There's nothing the SPA needs to do
// in the callback — the cookie is set before the browser is bounced back here.
function App() {
  return (
    <BffAuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Layout />}>
              <Route index element={<DashboardPage />} />
              <Route path="features" element={<FeaturesPage />} />
              <Route path="metrics" element={<MetricsPage />} />
              <Route path="metrics/:token" element={<MetricDetailPage />} />
              <Route path="clients" element={<ClientsPage />} />
              <Route path="clients/:clientId" element={<ClientDetailPage />} />
              <Route path="credits" element={<CreditsPage />} />
              <Route path="usage" element={<UsageActionsPage />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </BffAuthProvider>
  );
}

export default App;
